import { gaEvent } from 'src/utils'

/**
 * [TARGET]: No clique do ícone de edição do formulário de cartão de crédito.
 *
 * [CONTEXTO]: Na última etapa do link de pagamento, o usuário pode editar o formulário de cartão de crédito.
 *
 * [REGRAS]: n/a
 *
 */
export type EditFormSection = 'cartao-de-credito' | 'endereco-de-cobranca'
export const editFormEvent = (section: EditFormSection) => {
  const event = {
    event: 'event',
    'event-category': `pagamentos-sellout:cartao-de-credito`,
    'event-action': 'click:icon',
    'event-label': `editar-${section}`,
  }

  gaEvent(event)
}
